export const SESSION_KEY = 'screen_seat_data';
export const EXPIRY_DURATION = 1 * 60 * 60 * 1000; // 1 hour in milliseconds

export const saveScreenSeat = (screen, seat) => {
  const data = {
    screen,
    seat,
    timestamp: Date.now()
  };
  
  try {
    localStorage.setItem(SESSION_KEY, JSON.stringify(data));
    console.log('Session data saved:', data);
  } catch (error) {
    console.error('Error saving screen and seat data:', error);
  }
};

export const getScreenSeat = () => {
  try {
    const dataStr = localStorage.getItem(SESSION_KEY);
    if (!dataStr) return null;

    const data = JSON.parse(dataStr);
    const now = Date.now();
    
    // Check if data has expired
    if (now - data.timestamp > EXPIRY_DURATION) {
      localStorage.removeItem(SESSION_KEY);
      return null;
    }
    
    return data;
  } catch (error) {
    console.error('Error getting screen and seat data:', error);
    return null;
  }
};

export const clearScreenSeat = () => {
  try {
    localStorage.removeItem(SESSION_KEY);
  } catch (error) {
    console.error('Error clearing screen and seat data:', error);
  }
};
